import React, {useEffect, useState } from 'react'
import DetailsFinalProduct from './details/DetailsFinalProduct'
import DocsFinalProduct from './docs/DocsFinalProduct'

const FinalProductContainer = ({ item, idPresentation, onlyViewDocsProduct, isEditProductPresentation }) => {

    const [tabDetail, setTaDetails] = useState(true)

    const onClickViewDocs = () => {
        setTaDetails(false)
    }

    useEffect(() => {

    }, [tabDetail])

    return (
        <div style={{ display: 'flex'}}>
            {
             tabDetail  
             ? <DetailsFinalProduct  
                item={item} 
                idPresentation={idPresentation} 
                onClickViewDocs={onClickViewDocs}
                isEditProductPresentation={isEditProductPresentation}
                onlyViewDocsProduct= {onlyViewDocsProduct}
                />
             : <DocsFinalProduct 
                item={item} 
                idPresentation={idPresentation} 
                onlyViewDocsProduct= {onlyViewDocsProduct}
                isEditProductPresentation={isEditProductPresentation}
                />
        }
        </div>
    )
}

export default FinalProductContainer